<app-hero-section></app-hero-section>
<app-services-section></app-services-section>
<app-ats-resume-section></app-ats-resume-section>
<app-resume-builder-section></app-resume-builder-section>
<app-optimize-linkedin-section></app-optimize-linkedin-section>
<app-automate-section></app-automate-section>
<app-get-ready-section></app-get-ready-section>
